import Header from '../../components/Header'
import HeroBanner from '../../components/HeroBanner'
import HeroBannerAuthenticated from '../../components/HeroBannerAuthenticated'
import LeaderboardSection from '../../components/LeaderboardSection'
import CourseSection from '../../components/CourseSection'
import OtherServicesSection from '../../components/OtherServicesSection'
import ContactSection from '../../components/ContactSection'
import FAQSection from '../../components/FAQSection'
import { useTheme } from '../../contexts/ThemeContext'
import { useAuth } from '../../contexts/AuthContext'

export default function HomePage() {
  const { theme } = useTheme()
  const { isAuthenticated } = useAuth()

  return (
    <main className={`min-h-screen relative ${theme === 'dark' ? 'bg-black' : 'bg-gray-200'}`}>
      {/* Fixed Background Image - covers body but not header and footer, doesn't scroll */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <img
          src="/images/homepage-background.png"
          alt="SAIGON FC Training"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <Header />
      
      {/* Body Content with z-index to appear above background */}
      <div className="relative z-10">
        {isAuthenticated ? <HeroBannerAuthenticated /> : <HeroBanner />}
        <LeaderboardSection />
        {!isAuthenticated && <CourseSection />}
        {!isAuthenticated && <OtherServicesSection />}
        {isAuthenticated && <FAQSection />}
        {!isAuthenticated && <ContactSection />}
      </div>
    </main>
  )
}

